/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Heading/view.blocks to change it.
import CloseAction from './CloseAction/index'
import React from 'react'
import Title from './Title/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Heading({
  children,
  viewPath = "/App/Account/NewPatient/Content/Panes/Lead/Loading/Heading"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Heading.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Title
  viewPath={`${viewPath}/Title`}
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
{children}
</React.Fragment>)
}